export default class SaveForm {

    /**
     * Indica si el debug/log esta activo
     * @type {boolean}
     */
    debug = true;

    /**
     * Selector del formulario
     * @type {string}
     */
    formSelector = ".model-form";

    /**
     * Selector de la accion guardar
     * @type {string}
     */
    buttonSelector = ".js-save";

    /**
     * Offset del top al hacer scroll cuando hay error
     * @type {number}
     */
    offsetTop = 0;

    /**
     * Selector del contenedor/div para añadir errores genericos
     * @type {string}
     */
    jsFormErrorsSelector = ".model-form .js-form-errors";

    restUrl = null;
    restQuery = {};
    formUrl = null;
    urlPostSave = null;

    /**
     * Id cuando se guarda el formulario
     */
    idSaved = null;
    /**
     * The record is created new
     */
    _isNew = false;

    $_form = null;

    /**
     * Indica si el formulario se ha cambiado (para mostrar la alerta al salir de la pagina)
     * @type {boolean}
     */
    formChanged = false;

    /**
     * Indica si el detectar cambios esta habilitado (siempre se inicializa, pero se puede para la deteccion con esta variable)
     * @type {boolean}
     */
    detectChangesEnabled = true;

    /**
     * Logea, si esta activo, el mensaje
     * @param msg
     */
    log(msg){
        if(this.debug) {
            console.log("SaveForm: "+msg);
        }
    }

    /**
     * Obtiene el objeto jQuery con el formulario
     * @returns {*}
     */
    get$Form() {
        if (this.$_form==null) {
            this.$_form = $(this.formSelector);
            this.log("get$Form() -> " + this.formSelector);
        }
        return this.$_form;
    }

    /**
     * Recorre los componentes VUE de la página con relaciones 1-n y los guarda en un campo para que se puedan procesar
     */
    addToFormRelacitions1n() {
        this.log("addToFormRelacitions1n()");

        let $form = this.get$Form();
        if (window.relaciones1nVueComponents!==undefined) {
            window.relaciones1nVueComponents.forEach((relacion1nComponent,index)=> {
                let namePost =  relacion1nComponent.parameterPost;

                let $inputSelector = $form.find("input[name="+namePost+"]");
                if ($inputSelector.length==0) {
                    $form.append("<input type='hidden' name='"+namePost+"'/>");
                    $inputSelector = $form.find("input[name="+namePost+"]");
                }
                $inputSelector.val(JSON.stringify(relacion1nComponent.modelosHijos));
                //console.log(relacion1nComponent.modelosHijos);
            });
        }
    }

    validateAndSave() {
        this.log("validateAndSave()");
        let me = this;

        let $form = me.get$Form();
        me.addToFormRelacitions1n();
        let request = $form.serializeArray();

        // Para los elementos múltiples crea un array
        me.fillRequestWithAditionalData(request);

        //ckeditor
        if( typeof CKEDITOR !== 'undefined' ){
            for (var i in CKEDITOR.instances) {
                (function(i){
                    request.push({
                        name: CKEDITOR.instances[i].name,
                        value: CKEDITOR.instances[i].getData(),
                    });
                })(i);
            }
        }
        
        $(me.buttonSelector).prop("disabled",true);
        let xhr = $.ajax(me.restUrl,{
            method: "post",
            data: request,
            dataType: "json",
            success: function( data ) {
                //console.log(data);
                if (data.errorCode==0) {
                    me.idSaved=data.data["id"];
                    if ($("#id").val()=="") {
                        me._isNew=true;
                    } else {
                        me._isNew=false;
                    }
                    // Subir los archivos

                    me.showOkMessage();
                } else {
                    me.showErrorMessage(data.errorMessages);
                }
            },
            error: function( data ) {
                //console.log(data.responseText);
                me.showErrorMessage();
            }
        });
    }

    fillRequestWithAditionalData(request) {
        this.log("fillRequestWithAditionalData()");

        //console.log(this.restQuery);
        //console.log(request);
        $.each(this.restQuery, function(name, value) {
            request.push( {"name":name, "value":value} );
        });
        //console.log(request);
    }

    t(s) {
        return s
    }

    /**
     * Resetea un form-group a su estado inicial:
     * - Quita los mensajes de error
     * @param $formGroup
     */
    resetFormGroup($formGroup){
        //this.log("resetFormGroup()");
        let me = this;

        if($formGroup!==null && $formGroup!==undefined) {
            $formGroup.removeClass("has-error");
            $formGroup.removeClass("has-feedback");
            $formGroup.find(".js-error").remove();
            $formGroup.find("label").removeClass("text-danger");
            $formGroup.find("input,textarea,select").removeClass(["is-invalid", "text-danger"]);
        }
    }

    resetFormToSendData() {
        this.log("resetFormToSendData()");
        let me = this;

        let $form = me.get$Form();
        $(me.buttonSelector).prop("disabled",false);

        $form.find(".form-group").each(function(){
            me.resetFormGroup($(this));
        });

        let $jsFormErrors = $(me.jsFormErrorsSelector);
        $jsFormErrors.hide();
    }

    onSavedForm() {
        this.log("onSavedForm()");
        let me = this;

        let url = this.formUrl.replace("{id}",me.idSaved);
        if (url.indexOf("?")===-1) {
            url+="?";
        }
        url+="&saved=OK";
        window.actionClick = true;
        window.location.href = url;
    }

    showOkMessage() {
        this.log("showOkMessage()");

        let me=this;
        /*
         me.resetFormToSendData();
         $(".js-form-sucess").show().delay(2000).slideUp( 500 );
         */
        //console.log("showOkMessage");
        me.onSavedForm();
    }

    showMessageWithModal(msg) {
        this.log("showMessageWithModal()");

        //swal(msg);
        alert(msg);
    }

    showErrorMessage(messages, autoScroll = true) {
        this.log("showErrorMessage()");

        let $form = this.get$Form();
        $("#modal_cargando").remove();
        $(".modal-backdrop, .fade, .in").remove();
        //console.log("showErrorMessage. Error sending message");
        this.resetFormToSendData();
        let messageComplete = this.t("There was an error saving the form");
        //console.log("messages=>");
        //console.log(messages);
        let messagesWithoutFields=[];
        if (messages==null) {
            messageComplete = "Error saving data";
            this.showMessageWithModal(this.t("Error al guardar los datos"));
        } else if (typeof messages == "string") {
            this.showMessageWithModal(messages);
        } else {
            for(let message of messages) {
                if (message.field!="") {
                    //Ponemos el first para que coja el primer campo (para evitar campos de relation1n-vue)
                    let $input = $form.find("[name="+message.field+"]:first");
                    //console.log($input);
                    if ($input.length>0) {
                        let $formGroup = $input.closest(".form-group");
                        if (!$formGroup.hasClass("has-error")) {

                            $formGroup.addClass("has-error");
                            $formGroup.addClass("has-feedback");

                            //TODO Revisar si ponemos un icono FA (o quitamos este)
                            $formGroup.append("<i class='js-error form-control-feedback glyphicon glyphicon-remove'></i>");
                            $formGroup.append("<small class='js-error help-block text-danger'>"+message.errorMessage+"</small>");

                            $formGroup.find("label").addClass("text-danger");
                            $formGroup.find("input,textarea,select").addClass(["is-invalid","text-danger"]);
                            //TODO: Hacer que al añadirle a la clase input-group la clase is-invalid se aplique bien la CSS
                            //$formGroup.find(".input-group").addClass(["is-invalid","text-danger"]);
                        }
                        //alert(message.field);
                        //alert( $formGroup.size() );
                    } else {

                    }
                } else {
                    messagesWithoutFields.push(message.errorMessage);
                }
            }
            messageComplete = "Please check the errors in the form:";
            let messagesWithoutFieldsHtml = messagesWithoutFields.join("<br/>");
            messageComplete += "<br/>" + messagesWithoutFieldsHtml;
        }
        let $jsFormErrors = $(this.jsFormErrorsSelector);
        if (messagesWithoutFields.length>0) {
            $jsFormErrors.html(messageComplete);
            $jsFormErrors.show();

            if(autoScroll) {
                //Scroll al mensaje de error generico
                $([document.documentElement, document.body]).animate({
                    scrollTop: $jsFormErrors.offset().top - this.offsetTop
                }, 500);
            }
        } else {
            $jsFormErrors.hide();

            if(autoScroll) {
                //Scroll al primer elemento con error
                if ($(".form-group.has-error").length > 0) {
                    $([document.documentElement, document.body]).animate({
                        scrollTop: $(".form-group.has-error:first").offset().top - this.offsetTop
                    }, 500);
                }
            }
        }
    }
    /**
     * in is [ {name:1,value:4} ] y out is {"name":1}
     * @param nameValuePair
     * @returns {{}|*}
     */
    getAsPureArray(nameValuePair) {
        this.log("getAsPureArray()");

        let result={};
        $.each(nameValuePair, function(index, nameValue) {
            result[nameValue.name]=nameValue.value;
        });
        return result;
    }

    /**
     * Establece la pagina como con cambio
     * @param $elem
     */
    setPageAsChanged($elem) {
        this.log("setPageAsChanged("+$elem.attr("name")+")");
        var me = this;

        me.formChanged = true;

        //barra inferior con boton guardar
        if($(".fixedActions").length>0) {
            $(".fixedActions").addClass("show");
        }
    }

    /**
     * Inicializa los eventos del formulario para que caundo se pulse en "guardar" se activen los eventos necesarios
     */
    initEvents() {
        //this.log("initEvents()");
        let me = this;

        $(this.buttonSelector).click(function(){
            me.validateAndSave();
            return false;
        });

        //Al modificar un campo quitamos su mensaje de error
        let $form = this.get$Form();
        $form.find("input,textarea,select").change(function(){
            me.resetFormGroup($(this).closest(".form-group"));
        });

        //Marcar todos los campos como modificados
        //TODO Controlar con variable
        if($(".fixedActions").length>0) {
            $(".detectChanges").on("change", "input[type='text'],input[type='password'],select,textarea", function () {
                if(me.detectChangesEnabled) {
                    $(this).parents(".form-group").addClass("has-changes");
                    me.setPageAsChanged($(this));
                }
            });
            $(".detectChanges").on("change", "input[type='checkbox']", function () {
                if(me.detectChangesEnabled) {
                    $(this).next("label").addClass("has-changes");
                    me.setPageAsChanged($(this));
                }
            });
            $(".detectChanges").on("change", "input[type='radio']", function () {
                if(me.detectChangesEnabled) {
                    $(".detectChanges input[type='radio'][name='" + $(this).attr("name") + "'] + label").removeClass("changed");
                    $(this).next("label").addClass("has-changes");
                    me.setPageAsChanged($(this));
                }
            });

            //TODO Poner el correcto en la subida de documentos
            $(".detectChanges").on("change", ".uploadDocument input[type='file']", function () {
                if(me.detectChangesEnabled) {
                    $(this).parents("uploadDocument").addClass("has-changes");
                    me.setPageAsChanged($(this));
                }
            });

            $(window).bind('beforeunload', function () {
                if (me.formChanged && !window.actionClick) {
                    return "Va a abandonar la página sin guardar los cambios en la reclamación. ¿Esta seguro?";
                }
            });
        }
    }
}